import BaseObjectStore from './base-object.store';

class ErCategoryStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'erCategory';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new ErCategoryStore();
